<template>
  <div>
    <baseBack></baseBack>
    <div class="content" style="margin-top: 20px;">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户管理" name="user" v-loading="loading">

          <el-descriptions class="margin-top" title="用户信息" border>
            <template slot="extra">
              <el-button type="primary" size="small" @click="handleWithdraw">提现</el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                用户ID
              </template>
              {{user.id}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                用户名
              </template>
              {{user.openid}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                姓名
              </template>
              {{user.realname}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                佣金
              </template>
              <el-tag size="small">{{user.commissionPc}}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                注册时间
              </template>
              {{user.createTime}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                VIP到期
              </template>
              {{user.end}}
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="佣金记录" name="records" v-if="this.user.shareBonus>0">
          <el-table :data="list.data" style="width: 100%" height="600" border>
            <el-table-column fixed prop="id" label="ID" width="100">
              <template slot-scope="scop">
                <div>{{scop.row.id}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="realname" label="金额" width="100">
              <template slot-scope="scop">
                <div>{{scop.row.number}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="realname" label="类型" width="100">
              <template slot-scope="scop">
                <div>{{scop.row.type}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="时间" width="200">
              <template slot-scope="scop">
                <div>{{scop.row.createTime}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="realname" label="说明">
              <template slot-scope="scop">
                <div>{{scop.row.remark}}</div>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: flex-end;margin: 20px 0;">
            <basePagination :size="list.perPage" :page="list.currentPage" :total="list.total" @SizeChange='SizeChange'
              @CurrentChange='CurrentChange' />
          </div>
        </el-tab-pane>

        <el-tab-pane label="推广码" name="qrcode" v-if="this.user.shareBonus>0">
          <el-upload class="share-qrcode-uploader" :show-file-list="false" :auto-upload="false"
            :on-change="handleQrcodeChange" :before-upload="beforeQrcodeUpload">
            <img v-if="qr_imageUrl" :src="qr_imageUrl" class="avatar">
            <i v-else class="el-icon-plus share-qrcode-uploader-icon"></i>
          </el-upload>
          <el-button type="primary" @click="submitQrcode">保存推广码</el-button>
        </el-tab-pane>

        <el-tab-pane label="子账号" name="child_account" v-if="this.user.shareBonus>0">
          <el-button type="primary" size="small" @click="addChildAccount()">添加子账号</el-button>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="id" label="ID" width="120">
            </el-table-column>
            <el-table-column prop="openid" label="账号" width="120">
            </el-table-column>
            <el-table-column prop="realname" label="名称" width="120">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="150">
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="editChildCode(scope.row)">编辑分享码</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog title="申请提现" :visible.sync="dialogFormVisible">
      <div style="font-size: 0.625rem;color: blue;margin-bottom: 0.625rem;margin-left: 3.2rem;">
        <div>提现说明：&nbsp;&nbsp;最低提现金额：{{withdraw.withdraw_min_money}} 元 &nbsp;&nbsp;
          最高提现金额：{{withdraw.withdraw_max_money}} 元 &nbsp;&nbsp;手续费：{{withdraw.withdraw_fee_ratio}} %</div>
      </div>

      <el-form :model="form">
        <el-form-item label="提现金额" :label-width="formLabelWidth">
          <el-input v-model="form.amount" type="number" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" :label-width="formLabelWidth">
          <el-input v-model="form.real_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="到账方式" :label-width="formLabelWidth">
          <el-select v-model="form.payment_mode" placeholder="请选择到账方式">
            <el-option label="微信收款码" value="qrcode"></el-option>
            <el-option label="银行卡" value="bank"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="form.payment_mode=='bank'" label="收款银行" :label-width="formLabelWidth">
          <el-input v-model="form.bank_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="form.payment_mode=='bank'" label="银行卡号" :label-width="formLabelWidth">
          <el-input v-model="form.bank_card" type="number" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item v-if="form.payment_mode=='qrcode'" label="微信收款码" :label-width="formLabelWidth">
          <el-upload class="avatar-uploader" :show-file-list="false" :auto-upload="false" :on-change="handleFileChange"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitWithdraw">申请提现</el-button>
      </div>
    </el-dialog>


    <el-dialog title="添加子账号" :visible.sync="dialogFormVisible_account">
      <el-form :model="form_account">
        <el-form-item label="用于登录的用户名" :label-width="formLabelWidth">
          <el-input v-model="form_account.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用于登录的密码" :label-width="formLabelWidth">
          <el-input v-model="form_account.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" :label-width="formLabelWidth">
          <el-input v-model="form_account.realname" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible_account = false">取 消</el-button>
        <el-button type="primary" @click="submitAddAccount">提交</el-button>
      </div>
    </el-dialog>


    <!-- 给下级账号上传分享码 -->
    <el-dialog title="快速绑定分享码" :visible.sync="dialogFormVisible_child_code">
      <el-upload class="share-qrcode-uploader" :show-file-list="false" :auto-upload="false"
        :on-change="handleQrcodeChange_child" :before-upload="beforeQrcodeUpload">
        <img v-if="qr_imageUrl_child" :src="qr_imageUrl_child" class="avatar">
        <i v-else class="el-icon-plus share-qrcode-uploader-icon"></i>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible_child_code = false">取 消</el-button>
        <el-button type="primary" @click="submitChildCode">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import store from '@/store/index.js';
  import loader from '@/components/base/basePagination/controls.js'
  export default {
    mixins: [loader],
    data() {
      return {
        activeName: 'user',
        user: {},
        initial: {
          geturl: '/user/commission_pc',
          params: {}
        },
        list: {},
        loading: false,
        dialogFormVisible: false,
        form: {},
        formLabelWidth: '120px',
        headers: {},
        imageUrl: '',
        selectedFile: null,
        withdraw: {
          withdraw_min_money: 0,
          withdraw_max_money: 0,
          withdraw_fee_ratio: 0,
        },

        qr_imageUrl: '',
        qr_selectedFile: null,

        tableData: [],
        form_account: {},
        dialogFormVisible_account: false,
        dialogFormVisible_child_code: false,

        child_id: '',
        qr_imageUrl_child: '',
        qr_selectedFile_child: null,
      }
    },
    created() {
      this.headers.authorization = store.state.userInfo.token;
      this.getInformation()
      this.jiazai()
      this.jiazai_child_account()
      this.getWithdrawConfig()
    },
    methods: {
      async getInformation() {
        this.user = await this.axios.post('/user/information')
        this.qr_imageUrl = this.user.shareQrcode
      },
      async getWithdrawConfig() {
        let withdraw = await this.axios.post('/user/withdrawConfig')
        this.withdraw.withdraw_min_money = withdraw.withdrawMinMoney
        this.withdraw.withdraw_max_money = withdraw.withdrawMaxMoney
        this.withdraw.withdraw_fee_ratio = withdraw.withdrawFeeRatio
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleWithdraw() {
        let commission_pc = this.user.commissionPc
        if (commission_pc <= 0) {
          this.$alert('暂无可提现金额', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          })
          return
        }
        this.dialogFormVisible = true
      },
      editChildCode(row) {
        this.qr_imageUrl_child = row.shareQrcode
        this.child_id = row.id
        this.dialogFormVisible_child_code = true
      },
      jiazai() {
        this.getData(this.initial.params)
          .then(res => {
            this.list = res
          })
          .catch(err => {})
      },
      async jiazai_child_account() {
        const response = await this.axios.post('/User/child_account', {

        });
        console.log(response)
        this.tableData = response
      },
      handleFileChange(file) {
        this.selectedFile = file.raw;
        this.imageUrl = URL.createObjectURL(this.selectedFile);
      },
      handleFileChange_child(file) {
        this.selectedFile = file.raw;
        this.imageUrl_child_code = URL.createObjectURL(this.selectedFile);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;

        if (!(isJPG || isPNG)) {
          this.$message.error('只能上传JPG或PNG格式的图片');
          return false;
        }

        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
          return false;
        }
        return true;
      },
      async submitWithdraw() {
        if (!this.form.amount) {
          this.$message.error('请输入金额');
          return;
        }
        if (this.form.amount <= 0) {
          this.$message.error('金额不正确');
          return;
        }

        const amount = Number(this.form.amount);
        const commission = Number(this.user.commissionPc);
        if (amount > commission) {
          this.$message.error('可提现金额不足');
          return;
        }
        if (amount < this.withdraw.withdraw_min_money || amount > this.withdraw
          .withdraw_max_money) {
          this.$message.error('不符合的提现金额范围');
          return;
        }
        if (!this.form.real_name) {
          this.$message.error('请输入真实姓名');
          return;
        }

        if (!this.form.payment_mode) {
          this.$message.error('请选择到账方式');
          return;
        }

        if (this.form.payment_mode === 'bank') {
          if (!this.form.bank_name) {
            this.$message.error('请输入收款银行');
            return;
          }
          if (!this.form.bank_card) {
            this.$message.error('请输入银行卡号');
            return;
          }
        }


        if (this.form.payment_mode === 'qrcode' && !this.selectedFile) {
          this.$message.error('请上传微信收款码');
          return;
        }
        this.loading = true
        // 上传图片
        if (this.form.payment_mode === 'qrcode') {
          const response = await this.axios.post('/User/upload', {
            image: this.selectedFile
          }, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          if (response.ok == 1) {
            this.form.image = response.path
          } else {
            this.$message.error(response.msg);
            this.loading = false
            return;
          }
        }
        // // 提交申请
        const response = await this.axios.post('/User/withdraw_pc', {
          amount: this.form.amount || '',
          bank_name: this.form.bank_name || '',
          bank_card: this.form.bank_card || '',
          real_name: this.form.real_name || '',
          payment_mode: this.form.payment_mode || '',
          image: this.form.image || '',
        });
        this.loading = false
        if (response.ok == 1) {
          this.imageUrl = null
          this.getInformation()
          this.$message.success(response.msg);
          this.dialogFormVisible = false;
        } else {
          this.$message.error(response.msg);
          this.loading = false
          return;
        }
      },

      async submitQrcode() {
        if (!this.qr_selectedFile) {
          this.$message.error('请上传推广码');
          return;
        }
        let up_qr_img = ''
        const response = await this.axios.post('/User/upload', {
          image: this.qr_selectedFile
        }, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if (response.ok == 1) {
          up_qr_img = response.path
        } else {
          this.$message.error(response.msg);
          this.loading = false
          return;
        }


        this.loading = true
        // 提交申请
        const response2 = await this.axios.post('/User/save_qrcode', {
          image: up_qr_img
        });
        this.loading = false
        if (response2.ok == 1) {
          this.qr_imageUrl = null
          this.getInformation()
          this.$message.success(response2.msg);
          this.dialogFormVisible = false;
        } else {
          this.$message.error(response2.msg);
          this.loading = false
          return;
        }
      },
      //上传推广码
      handleQrcodeChange(file) {
        this.qr_selectedFile = file.raw;
        this.qr_imageUrl = URL.createObjectURL(this.qr_selectedFile);
      },
      handleQrcodeChange_child(file) {
        this.qr_selectedFile_child = file.raw;
        this.qr_imageUrl_child = URL.createObjectURL(this.qr_selectedFile_child);
      },
      beforeQrcodeUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;

        if (!(isJPG || isPNG)) {
          this.$message.error('只能上传JPG或PNG格式的图片');
          return false;
        }

        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
          return false;
        }
        return true;
      },
      addChildAccount() {
        let shareBonus = this.user.shareBonus
        if (shareBonus <= 0) {
          this.$alert('请联系管理员开通分销权限', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          })
          return
        }
        this.dialogFormVisible_account = true
      },
      async submitAddAccount() {
        if (!this.form_account.username) {
          this.$message.error('请输入用户名');
          return;
        }
        if (!this.form_account.password) {
          this.$message.error('请输入密码');
          return;
        }
        if (!this.form_account.realname) {
          this.$message.error('请输入姓名');
          return;
        }

        // // 提交申请
        const response = await this.axios.post('/User/add_child_account', {
          username: this.form_account.username || '',
          password: this.form_account.password || '',
          realname: this.form_account.realname || '',
        });
        this.loading = false
        if (response.ok == 1) {
          this.form_account = {}
          this.jiazai_child_account()
          this.$message.success(response.msg);
          this.dialogFormVisible_account = false;
        } else {
          this.$message.error(response.msg);
          this.loading = false
          return;
        }
      },
      async submitChildCode() {
        if (!this.qr_selectedFile_child) {
          this.$message.error('请上传推广码');
          return;
        }
        let up_qr_img = ''
        const response = await this.axios.post('/User/upload', {
          image: this.qr_selectedFile_child
        }, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if (response.ok == 1) {
          up_qr_img = response.path
        } else {
          this.$message.error(response.msg);
          this.loading = false
          return;
        }



        this.loading = true
        // 提交申请
        const response2 = await this.axios.post('/User/edit_child_code', {
          image: up_qr_img,
          child_id: this.child_id || '',
        });

        this.loading = false
        if (response2.ok == 1) {
          this.qr_imageUrl_child = null
          this.jiazai_child_account()
          this.$message.success(response2.msg);
          this.dialogFormVisible_child_code = false;
        } else {
          this.$message.error(response2.msg);
          this.loading = false
          return;
        }
      }
    }
  }
</script>

<style>
  .el-table .cell {
    padding-left: 7px;
    display: flex;
    justify-content: space-around;
  }

  .el-button+.el-button,
  .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .el-button--mini,
  .el-button--mini.is-round {
    padding: 7px 10px;
  }

  .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #ebeef5;
    text-align: center;
  }

  .el-dialog__body {
    padding: 30px 20px;
    color: #606266;
    font-size: 22px;
    word-break: break-all;
  }

  .content {
    width: 1200px;
    /* margin-left: 350px; */
    margin: auto;
  }

  .el-popup-parent--hidden {
    overflow: hidden;
    padding-right: 0 !important;
  }


  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }


  /* 推广码 */
  .share-qrcode-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .share-qrcode-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .share-qrcode-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/user.vue